import type {VariantProps} from "class-variance-authority";

import {badgeVariants} from "@/components/ui/badge";

import type {CompanyVehicleStatus} from "../types";

/** UI labels: Title Case. API values remain lowercase enums. */
const STATUS_LABELS: Record<CompanyVehicleStatus, string> = {
  active: "Active",
  inactive: "Inactive",
  maintenance: "Maintenance",
  retired: "Retired",
};

export type CompanyVehicleStatusBadgeVariant = NonNullable<
  VariantProps<typeof badgeVariants>["variant"]
>;

/**
 * Maps API status to badge variant (aligned with DAR-style chips: success = on track, error = blocked OOS, etc.).
 */
export function getCompanyVehicleStatusBadgeVariant(
  status: string | null | undefined,
): CompanyVehicleStatusBadgeVariant {
  const key = String(status ?? "").trim().toLowerCase();
  if (key === "active") {
    return "success";
  }
  if (key === "inactive") {
    return "error";
  }
  if (key === "maintenance") {
    return "warning";
  }
  if (key === "retired") {
    return "danger";
  }
  return "secondary";
}

export function formatCompanyVehicleStatusLabel(value: string | null | undefined): string {
  if (value == null || String(value).trim() === "") {
    return "—";
  }
  const key = String(value).trim().toLowerCase() as CompanyVehicleStatus;
  if (key in STATUS_LABELS) {
    return STATUS_LABELS[key];
  }
  return key.charAt(0).toUpperCase() + key.slice(1);
}